import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ReportService } from './report.service';
import { OrdersDataService } from './orders-data.service';

const SETTLED_STATUS_IDS = [5, 6];


@Injectable({ providedIn: 'root' })
export class PaymentReceiptService {
  constructor(private report: ReportService, private ordersData: OrdersDataService) { }


  async generateIfNewlySettled(priorStatusId: number | null | undefined, payment: any, customerName?: string): Promise<string | null> {
    const wasSettled = priorStatusId != null && SETTLED_STATUS_IDS.includes(priorStatusId);
    const isNowSettled = SETTLED_STATUS_IDS.includes(payment.StatusID);
    if (wasSettled || !isNowSettled) return null;

    const base64Pdf = await this.report.generatePDF('PaymentReceipt', { payment, customerName });
    const resp: any = await lastValueFrom(this.ordersData.uploadPaymentReceipt(payment.OrderPaymentID, payment.OrderID, base64Pdf));
    return resp?.ReceiptBlobPath || null;
  }
}
